import { Link } from "react-router-dom";
import { ArrowUpRight, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const BrandCard = ({ brand }) => {
  return (
    <Card className="card-hover flex h-full flex-col border-border bg-card p-6">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-display text-2xl font-bold text-foreground">{brand.name}</p>
          <p className="mt-1 text-sm font-medium text-accent">{brand.tagline}</p>
        </div>
        <a
          href={brand.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Visit ${brand.name} website`}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground"
        >
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
      <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{brand.blurb}</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {brand.categories.slice(0, 3).map((c) => (
          <span key={c} className="rounded-full bg-muted px-3 py-1 text-xs font-medium text-foreground/80">{c}</span>
        ))}
      </div>
      <Button asChild variant="ghost" className="mt-auto w-fit pt-2 px-0 text-foreground hover:bg-transparent hover:text-accent">
        <Link to={`/brands/${brand.slug}`}>
          View resources <ChevronRight className="h-4 w-4" />
        </Link>
      </Button>
    </Card>
  );
};
